"use client";

import React from "react";
import { Facebook, Instagram, MapPin, Phone, ArrowUp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="68042" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-5 w-24 animate-pulse rounded bg-white/10" />)}
      </div>;
  }
  return <nav className="flex flex-col gap-3">
      <Link to="/#六大專業服務流程" className="text-white hover:text-white transition-colors text-sm hover:underline" style={{
      color: "white"
    }}>
        服務流程
      </Link>
      <Link to="/#助聽器補助申請" className="text-white hover:text-white transition-colors text-sm hover:underline" style={{
      color: "white"
    }}>
        助聽器補助
      </Link>
      <Link to="/HomeInspectionPage" className="text-white hover:text-white transition-colors text-sm hover:underline" style={{
      color: "white"
    }}>
        到府檢測
      </Link>
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-white hover:text-white transition-colors text-sm hover:underline">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  return <section id="頁尾資訊" className="bg-secondary py-16 text-secondary-foreground dark">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="flex flex-col items-start gap-4">
            <Link to="/HomePage" className="block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598117/img/zaza_hair_logo_footer.png" alt="瑞聲助聽器到府服務團隊" className="h-7 w-auto object-contain brightness-0 invert" />
            </Link>
            <p className="text-sm leading-relaxed max-w-xs text-white/70">
              專業助聽器到府服務團隊，致力於為每一位客戶提供最貼心的聽力照護，讓溝通不再有距離，重拾生活美好旋律。
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <h3 className="text-white font-sans text-lg font-bold tracking-wide">快速連結</h3>
            <MenuProvider menu_id="footer_menu" className="w-full">
              <FooterLinks />
            </MenuProvider>
          </div>

          <div className="flex flex-col gap-4">
            <h3 className="text-white font-sans text-lg font-bold tracking-wide">服務專線</h3>
            <div className="flex flex-col gap-3 text-sm">
              <div className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <span className="text-white/70">提供全台到府服務預約諮詢</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="h-4 w-4 shrink-0 text-primary" />
                <Link to="tel:0800555705" className="text-white font-bold hover:text-primary transition-colors text-base">
                  0800 555 705
                </Link>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <span className="text-white/70">北部到府團隊：新北市淡水區中山路78號</span>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <span className="text-white/70">中部到府團隊：台中市南屯區黎明路一段1030號</span>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <span className="text-white/70">南部到府團隊：台南市北區成功路2段5樓4室</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <h3 className="text-white font-sans text-lg font-bold tracking-wide">關注我們</h3>
            <div className="flex gap-4">
              <Link to="https://www.instagram.com/resound_9" newTab className="bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-primary hover:text-primary-foreground flex h-10 w-10 items-center justify-center rounded-sm shadow-md transition-all duration-300" aria-label="Instagram">
                <Instagram className="h-5 w-5" />
              </Link>
              <Link to="https://facebook.com/res26228249/" newTab className="bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-primary hover:text-primary-foreground flex h-10 w-10 items-center justify-center rounded-sm shadow-md transition-all duration-300" aria-label="Facebook">
                <Facebook className="h-5 w-5" />
              </Link>
            </div>
          </div>
        </div>

        <div className="border-white/10 mt-16 flex flex-col items-center justify-between gap-4 border-t pt-8 md:flex-row">
          <p className="text-xs text-white/50">
            &copy; {new Date().getFullYear()} 瑞聲助聽器到府服務團隊 | 睿聲助聽器授權公司. 隱私權政策.
          </p>
          <Button variant="outline" size="sm" onClick={scrollToTop} className="gap-2 rounded-sm bg-transparent border-white/20 text-white hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all cursor-pointer">
            回到頂部
            <ArrowUp className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </section>;
}